import React from 'react';

export function DeviceHubIcon({ color, ...restProps }: React.SVGProps<SVGSVGElement>) {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...restProps}>
            <path
                d="M13.5517 12.7074L10.3617 9.56428L10.3431 7.04685C11.2589 6.70756 11.9174 5.83183 11.9098 4.8027C11.9001 3.48857 10.8315 2.43561 9.51732 2.44533C8.20319 2.45506 7.15024 3.52371 7.15996 4.83784C7.16757 5.86698 7.839 6.73287 8.75977 7.05856L8.77839 9.57599L5.63524 12.766L2.46866 12.7894L2.49795 16.7477L6.45617 16.7184L6.43831 14.3039L9.58029 10.9555L12.7715 14.257L12.7893 16.6715L16.7476 16.6422L16.7183 12.684L13.5517 12.7074Z"
                fill={color ?? '#717680'}
            />
        </svg>
    );
}
